import { RemoteSaveNotificationToken } from '@/data/usecases'
import { makeAxiosHttpClient } from '@/main/factories/http'
import { SaveNotificationToken } from '@/domain/usecases'
import env from '@/main/config/env'

export const makeSaveNotificationToken = (): SaveNotificationToken => {
  const url = env.API_URL
  const httpClient = makeAxiosHttpClient<string>()

  return new RemoteSaveNotificationToken(url, httpClient)
}
